import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import Swal from "sweetalert2";

import { jwtDecode } from 'jwt-decode';
import { EncryptionService } from 'src/app/services/encryption.service';
import { OrganizerSessionService } from 'src/app/services/organizer-session.service';

@Component({
  selector: 'app-gst-registration',
  templateUrl: './gst-registration.component.html',
  styleUrls: ['./gst-registration.component.scss']
})
export class GstRegistrationComponent implements OnInit {

  @ViewChild('fileInput') fileInput!: ElementRef;

  legalForm!: FormGroup;
  Ttoken: any;
  gstForm: FormGroup;
  selectedFileName: string | null = null;
  isAgreed: boolean = false;
  isNotRegistered: boolean = false
  isRegistered: boolean = true;
  decryptedData: any = []
  encryptOrgID: any;
  showSecondaryBtn = true;
  public formfillNext: boolean = false;
  public onlyhideYes: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _ds: DataService,
    private route: ActivatedRoute,
    private enc: EncryptionService,
    private organizerSession: OrganizerSessionService
  ) {

    this.gstForm = this.fb.group({
      gstRegistered: [null]
    });
  }

  ngOnInit(): void {
    // this.route.queryParamMap.subscribe(params => {
    //   const token = params.get('token');
    //   this.Ttoken = params.get('token');
    //   if (!token) return;

    //   const decoded = jwtDecode<OrganizerApprovalPayload>(token);

    //   console.log('FULL TOKEN 👉', decoded);
    //   this.organizer = decoded.organizer;

    //   console.log('Company 👉', this.organizer.id);
    // });

    this.legalForm = this.fb.group({
      gstNumber: [
        '',
        [
          Validators.required,
          Validators.maxLength(15),
          Validators.minLength(15),
          Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)
        ]
      ],
      gstFile: [null, Validators.required]
    });

    this.route.queryParams.subscribe(params => {
      const id = this.organizerSession.validateRouteOrganizerId(
        params['id'],
        '/gst-registration',
        this.router
      );
      if (id == null) return;

      this._ds.getUniqueUserData(id).subscribe((res: any) => {
        const allData = this.enc.decrypt(res.data);
        console.log(allData)
        // console.log(allData.documents.gst[0].gst_number)

        if (allData.documents.gst_exists == true) {
          this.formfillNext = true
          Object.keys(this.legalForm.controls).forEach(key => {
            this.legalForm.get(key)?.disable();
          });

          setTimeout(() => {
            this.legalForm.patchValue({
              gstNumber: allData.documents.gst[0].gst_number,               // 👈 YAHI FIX HAI
              gstFile: allData.documents.gst[0].document_path,
              // eventsPerYear: allData.organizer.events_per_year_range
            });
            this.selectedFileName = allData.documents.gst[0].document_path
          }, 500);

        } else if (allData.organizer.has_gst == 1) {
          this.onlyhideYes = true
          this.formfillNext = false
          this.isNotRegistered = true
          this.isAgreed = true
          // this.legalForm.get('isAgreed')?.disable();
        } else {
          this.formfillNext = false

        }

      });
    });

  }



  onAgreementChange(event: any) {
    console.log('Checkbox value:', this.isAgreed);

    if (this.isAgreed) {
      console.log('User agreed');

    } else {
      console.log('User unchecked');
    }
  }

  submitAgree() {
    if (this.isAgreed) {
      const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
      const user = JSON.parse(localStorage.getItem('user') || 'null');

      // 🔥 pehle user.organizer se try karo
      const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
      const orgId = user?.organizer?.id || organizer?.id;

      if (!orgType || !orgId) {
        console.error('❌ Organizer data missing in both user & organizer');
        return;
      }

      this.updateGSTSKip()
      this.router.navigate(['/platform-legal'], { queryParams: { id: orgId } });
    }
  }

  triggerFile() {
    const fileInput = document.getElementById('panFile') as HTMLElement;
    fileInput.click();
  }

  selectOption(value: boolean) {
    this.isRegistered = value;
    this.isNotRegistered = false
    this.isAgreed = false;
    if (!value) {
      this.isNotRegistered = true
    }
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/login'], { replaceUrl: true });
  }
  // fileChangeEvent(event: any): void {
  //   const file = event.target.files[0];


  onFileSelect(event: any): void {
    const file: File = event.target.files?.[0];
    const control = this.legalForm.get('gstFile');

    if (!file) return;

    // ✅ File type validation
    const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'];
    if (!allowedTypes.includes(file.type)) {
      this.legalForm.get('gstFile')?.setErrors({ invalidType: true });
      this.selectedFileName = '';
      return;
    }

    // ✅ File size validation (max 2MB)
    const maxSize = 3 * 1024 * 1024; // 3MB

    if (file.size > maxSize) {
      control?.setErrors({ maxSize: true });
      control?.markAsTouched();
      control?.markAsDirty();
      this.selectedFileName = '';
      event.target.value = '';
      return;
    }
    // if (file.size > maxSize) {
    //   this.legalForm.get('gstFile')?.setErrors({ maxSize: true });
    //   this.selectedFileName = '';
    //   return;
    // }


    // ✅ UI update
    this.selectedFileName = file.name;

    // ✅ FormControl update (important 🔥)
    this.legalForm.patchValue({
      gstFile: file
    });
    this.legalForm.get('gstFile')?.updateValueAndValidity();

    // ✅ API upload
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizerId =
      organizer?.id
        ? organizer.id
        : user?.organizer?.id
          ? user.organizer.id
          : null;

    const firstName =
      organizer?.first_name
        ? organizer.first_name
        : user?.organizer?.first_name
          ? user.organizer.first_name
          : null;

    const lastName =
      organizer?.last_name
        ? organizer.last_name
        : user?.organizer?.last_name
          ? user.organizer.last_name
          : null;

    const formData = new FormData();
    formData.append('organizer_name', firstName + ' ' + lastName);
    formData.append('organizer_id', organizerId);
    formData.append('kyc_type', 'gst');

    formData.append('file', file);

    this._ds.uploadDoucment(formData).subscribe({
      next: (res: any) => {
        console.log('Raw success res:', res);

        if (res?.data && typeof res.data === 'string') {
          const decrypted = this.enc.decrypt(res.data);
          console.log('Decrypted success:', decrypted);

          this.decryptedData = decrypted;

          // 🔥 upload success = field valid
          this.legalForm.get('gstFile')?.setErrors(null);
        } else {
          console.log('Success data not encrypted:', res.data);
        }
      },

      error: (err) => {
        console.log('Raw error:', err);

        // ❌ upload fail = field invalid
        this.legalForm.get('gstFile')?.setErrors({ uploadFailed: true });

        if (err?.error?.data && typeof err.error.data === 'string') {
          const decryptedErr = this.enc.decrypt(err.error.data);
          console.log('Decrypted error:', decryptedErr);
        } else {
          console.log('Error data not encrypted:', err?.error);
        }
      }
    });
  }


  submit() {

    if (this.legalForm.invalid) {
      this.legalForm.markAllAsTouched();
      return;
    }

    const payload = {
      gst_number: this.legalForm.value.gstNumber,
      document_type: 'gst_num',
      document_path: this.decryptedData.url
    };

    console.log('FORM DATA 👉', payload);

    // let data = localStorage.getItem('organizer');
    // const organizer = data ? JSON.parse(data) : null;

    // const organizeID = {
    //   organizer_id: organizer?.id,
    // };

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    let organizeID = {
      organizer_id: organizer?.id || user?.organizer?.id || null
    };

    this._ds.getDataOrganizerId(organizeID).subscribe({
      next: (res: any) => {
        this.encryptOrgID = this.enc.decrypt(res.data)

        this._ds.gstDocumentSubmit(this.encryptOrgID.url_safe_organizer_id, payload).subscribe({
          next: (res: any) => {
            if (res?.data) {
              const decryptedData = this.enc.decrypt(res.data);
              this.router.navigate(['/platform-legal']);
            }
          },
          error: (err) => {
            if (err?.error?.data) {
              const decryptedData = this.enc.decrypt(err.error.data);

              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 1800,
                timerProgressBar: true,
              });

              Toast.fire({ title: decryptedData.error });
            }
          }
        });
      }
    });
  }

  afterVerificationGST() {

    // if (this.legalForm.invalid) {
    //   this.legalForm.markAllAsTouched();
    //   return;  
    // }

    const payload = {
      gst_number: this.legalForm.value.gstNumber,
      document_type: 'gst_num',
      document_path: this.decryptedData.url
    };

    console.log('FORM DATA 👉', payload);

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    const organizeID = {
      organizer_id: organizer?.id || user?.organizer?.id || null
    };

    this._ds.getDataOrganizerId(organizeID).subscribe({
      next: (res: any) => {
        this.encryptOrgID = this.enc.decrypt(res.data)

        this._ds.gstDocumentSubmit(this.encryptOrgID.url_safe_organizer_id, payload).subscribe({
          next: (res: any) => {
            if (res?.data) {
              const decryptedData = this.enc.decrypt(res.data);
              this.router.navigate(['/platform-legal']);
            }
          },
          error: (err) => {
            if (err?.error?.data) {
              const decryptedData = this.enc.decrypt(err.error.data);

              const Toast = Swal.mixin({
                toast: true,
                position: "top",
                showConfirmButton: false,
                timer: 1800,
                timerProgressBar: true,
              });

              Toast.fire({ title: decryptedData.error });
            }
          }
        });
      }
    });
  }

  // submit() {

  //   if (this.legalForm.invalid) {
  //     this.legalForm.markAllAsTouched();
  //     return;
  //   }

  //   const payload = {
  //     reference_id: "ref_12345",
  //     id_number: this.legalForm.value.gstNumber,
  //     consent: "Y",
  //     consent_purpose: "GST verification for onboarding"
  //   };

  //   console.log('FORM DATA 👉', payload);

  //   this._ds.verifyGSTDetails(payload).subscribe({
  //     next: (res: any) => {
  //       if (res?.data) {
  //         const decryptedData = this.enc.decrypt(res.data);
  //         console.log(decryptedData.result)

  //         if (decryptedData.result.kycStatus == "SUCCESS") {
  //           localStorage.setItem('GSTIN', decryptedData.result.kycResult.pan)
  //           this.afterVerificationGST()
  //           this.router.navigate(['/platform-legal']);
  //         } else {
  //           const Toast = Swal.mixin({
  //             toast: true,
  //             position: "top",
  //             showConfirmButton: false,
  //             timer: 2800,
  //             timerProgressBar: true,
  //           });

  //           Toast.fire({ title: decryptedData.result.error.message });
  //         }
  //       }
  //     },
  //     error: (err) => {
  //       if (err?.error?.data) {
  //         const decryptedData = this.enc.decrypt(err.error.data);

  //         const Toast = Swal.mixin({
  //           toast: true,
  //           position: "top",
  //           showConfirmButton: false,
  //           timer: 1800,
  //           timerProgressBar: true,
  //         });

  //         Toast.fire({ title: decryptedData.error });
  //       }
  //     }
  //   });
  // }


  back() {
    // this.router.navigate(['/event-information']); 
    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

    if (!orgType || !orgId) {
      console.error('❌ Organizer data missing in both user & organizer');
      return;
    }
    this.router.navigate(['/event-information'], { queryParams: { id: orgId } });

  }

  onGstInput(event: Event) {
    const input = event.target as HTMLInputElement | null;
    if (!input) return;

    const value = input.value.toUpperCase();
    this.legalForm.get('gstNumber')?.setValue(value, { emitEvent: false });
  }

  //  selectOption(value: boolean) {
  //   this.gstForm.patchValue({ gstRegistered: value });
  // }

  // get isNotRegistered() {
  //   return this.gstForm.get('gstRegistered')?.value === false;
  // }

  // get isRegistered() {
  //   return this.gstForm.get('gstRegistered')?.value === true;
  // }
  next() {
    const id = this.organizerSession.getSessionOrganizerId();
    if (id == null) return;
    this.router.navigate(['/platform-legal'], { queryParams: { id } });
  }

  updateGSTSKip() {
    const payload = {
      has_gst: 1,
    };

    const organizer = JSON.parse(localStorage.getItem('organizer') || 'null');
    const user = JSON.parse(localStorage.getItem('user') || 'null');

    // 🔥 pehle user.organizer se try karo
    const orgIdorgType = user?.organizer?.organizer_type || organizer?.organizer_type;
    const orgId = user?.organizer?.id || organizer?.id;

    // if (!orgType || !orgId) {

    // }

    // alert(orgId)
    this._ds.updateSKIPGST(payload, orgId).subscribe({
      next: (res: any) => {
        this.enc.decrypt(res.data)
        console.log(res.data)

      }
    })

  }

}
